<template>
	<div style="min-height: 100%; width: 100%;">
		<div class="landing-page-header bg-min-height">
			<div class="landing-page-header__gradient" style="z-index: 1;">
				<v-layout column align-center justify-center style="height: 100%!important;">
					<img
						class="landing-page-header__logo"
						src="//wrkprty.imgix.net/backgrounds/homepage-logo.png"
						alt="WRKPRTY"
					/>
					<h1 class="mt-5" style="color: white;">Wrkprty tagline goes here</h1>
					<!-- <v-btn
						class="btn-min-height btn-blue mt-5 btn-large elevation-2 linkedin-login-btn"
						dark
						@click="loginRedirectLinkedin"
						:loading="loginRedirecting"
						ref="loginLinkedinButton"
					>
						{{ loginRedirecting ? 'Loading...' : 'Sign in with LinkedIn' }}
					</v-btn>
					<v-btn class="btn-min-height" flat dark @click="WhyLinkedinModal = true">
						Why LinkedIn?
					</v-btn> -->
					<div class="host-info-header__scroll-icon"><button type="button" @click="scrollDownPage"><i class="fas fa-chevron-down"></i></button></div>
				</v-layout>
			</div>
		</div>
		<div id="landing-page-content" class="landing-page-content-one pt-5 pb-5">
			<h2 class="landing-page-content-one-text">Wrkprty is great! Other great things about wrkprty. Its so cool and fun, blah blah blah come work with us and get a lot of work done and have fun and meet fun people. Put stuff here to explain it to people so they click the button and sign up.</h2>
			<v-btn flat class="mt-5 info landing-page__login-button">Call to action</v-btn>
		</div>
		<lory class="landing-page__carousel" :options="{ slideSpeed: 300, enableMouseEvents: true, infinite: 3, interval: 10000 }">
			<item class="carousel-item">
				<img
					class="carousel-image"
					src="https://wrkprty.imgix.net/backgrounds/host-info-girl-computer.jpg?q=65&w=400"
					alt="WRKPRTY"
				/>
			</item>
			<item class="carousel-item">
				<img
					class="carousel-image"
					src="https://wrkprty.imgix.net/backgrounds/host-info-handshake.jpg?q=65&w=400"
					alt="WRKPRTY"
				/>
			</item>
			<item class="carousel-item">
				<img
					class="carousel-image"
					src="https://wrkprty.imgix.net/backgrounds/host-info-girl-computer.jpg?q=65&w=400"
					alt="WRKPRTY"
				/>
			</item>
			<item class="carousel-item">
				<img
					class="carousel-image"
					src="https://wrkprty.imgix.net/backgrounds/host-info-handshake.jpg?q=65&w=400"
					alt="WRKPRTY"
				/>
			</item>
			<item class="carousel-item">
				<img
					class="carousel-image"
					src="https://wrkprty.imgix.net/backgrounds/host-info-girl-computer.jpg?q=65&w=400"
					alt="WRKPRTY"
				/>
			</item>
			<item class="carousel-item">
				<img
					class="carousel-image"
					src="https://wrkprty.imgix.net/backgrounds/host-info-handshake.jpg?q=65&w=400"
					alt="WRKPRTY"
				/>
			</item>
			<!-- <item class="carousel-image" v-for="(item, index) in images" :key="index" style="width: 100%;">
				<div :style="backgroundImageStyle(item.image)"></div>
			</item> -->
		</lory>
		<div class="landing-page__content-two">
			<div class="landing-page__content-two__icon-container">
				<i class="fas fa-users" style="font-size: 10.0em;"></i>
				<h3>Something about Wrkprty</h3>
			</div>
			<div class="landing-page__content-two__icon-container">
				<i class="fas fa-laptop" style="font-size: 10.0em;"></i>
				<h3>Something else about wrkprty</h3>
			</div>
			<div class="landing-page__content-two__icon-container">
				<i class="fas fa-handshake" style="font-size: 10.0em;"></i>
				<h3>Last thing about wrkprty</h3>
			</div>
		</div>
		<div class="landing-page__bottom-fullscreen-image">
			<div class="landing-page__bottom-fullscreen-image__gradient" style="z-index: 1;">
				<div class="landing-page__content-three">
					<h2>Final points about wrkprty</h2>
					<v-btn flat class="mt-5 info landing-page__login-button">Call to action</v-btn>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { Item } from 'vue-lory'
import Lory from '~/components/LoryCarousel.vue'

import axios from 'axios'
import { mapActions, mapGetters } from 'vuex'
import { makeid } from '~/store/util/util'
export default {
	name: 'testhome',
	data() {
		return {
			loginRedirecting: false,
			linkedin_oauth_token: '',
			showWhyLinkedinModal: false,
		}
	},
	created () {
		if ('serviceWorker' in navigator) {
			console.log(navigator)
			console.log(navigator.serviceWorker)
			navigator.serviceWorker.register('/service-worker.js').then(function(registration) {
				// Registration was successful
				console.log('ServiceWorker registration successful with scope: ', registration.scope)
			}, function(err) {
				// registration failed :(
				console.log('ServiceWorker registration failed: ', err)
			})
		}
	},
	methods: {
		...mapActions([
			'setMobileNavActive',
			'setModalOpen',
			'setAuthRedirect',
			'setAuthModalOpen',
			'signUserInLinkedin',
			'setUserSocial',
			'setToken'
		]),
		scrollDownPage() {
			// window.scrollTo(0, 200)
			document.querySelector('#landing-page-content').scrollIntoView({
				behavior: 'smooth',
				block: 'start'
			})
		},
		loginRedirectLinkedin() {
			this.loginRedirecting = true
			const userLoginHash = makeid(24)
			// console.log(userLoginHash)
			window.localStorage.setItem('login_hash', userLoginHash)
			axios({
				method: 'get',
				url: '/rest-auth/linkedin/requestToken/',
				params: {
					user_hash: userLoginHash
				},
				withCredentials: false,
				headers: {
					'Content-Type': 'application/json'
				},
				transformRequest: (data, headers) => {
					delete headers['Authorization']
					delete headers.common['Authorization']
					return data
				}
			})
				.then(response => {
					// console.log('loginRedirectLinkedin')
					// console.log(response)
					this.linkedin_oauth_token = response.data
					// window.location.href = this.linkedInAuthUrl
					// this.loginRedirecting = false
					window.location = this.linkedInAuthUrl
				})
				.catch(error => {
					this.loginRedirecting = false
					console.error('linkedin error')
					console.error(error)
				})
		}
	},
	computed: {
		...mapGetters(['getVisitorLocation', 'getModalProp']),
		linkedInAuthUrl() {
			return (
				'https://www.linkedin.com/uas/oauth/authenticate?oauth_token=' +
				this.linkedin_oauth_token +
				'&state='
			)
		},
		isMobile() {
			if (this.$vuetify.breakpoint.name === 'xs') {
				return true
			} else {
				return false
			}
		},
		WhyLinkedinModal: {
			get() {
				return this.getModalProp('whyLinkedinModal')
			},
			set(val) {
				this.setModalOpen({ prop: 'whyLinkedinModal', value: val })
			}
		},
		backgroundImageStyle(image) {
			let style = {
				'background-image': 'url(' + image + ')',
				'background-position': 'center',
				'background-size': 'cover',
				'background-repeat': 'no-repeat',
				height: '100%'
			}
			return style
		},
	},
	components: {
		Lory,
		Item
	}
}
</script>

<style lang="scss" scoped>
.landing-page-header {
	background: url('//wrkprty.imgix.net/backgrounds/landing.jpg?q=70&auto=format')
		no-repeat center center;
	-webkit-background-size: cover;
	-moz-background-size: cover;
	-o-background-size: cover;
	background-size: cover;
	position: absolute;
	left: 0;
	top: 0;

	width: 100vw;
	&__gradient {
		position: absolute;
		top: 0px;
		left: 0px;
		opacity: 0.99;
		z-index: 1;
		width: 100%;
		/*height: 150px;*/
		height: 100%;
		background: linear-gradient(
			to bottom,
			rgba(0, 0, 0, 0.35) 0%,
			rgba(0, 0, 0, 0) 22%,
			rgba(0, 0, 0, 0) 65%,
			rgba(12, 12, 12, 0.5) 85%,
			rgba(12, 12, 12, 1) 98%
		);
	}
}

.landing-page-header__logo {
	margin-top: -15vh;
	width: 45vw;
}

@media screen and (max-width: 600px) {
	.landing-page-header__logo {
		width: 65vw;
	}
}

.landing-page-gradient-foreground {
	z-index: 1;

	background: linear-gradient(
		to bottom,
		rgba(0, 0, 0, 0) 0%,
		rgba(150, 150, 150, 0) 60%,
		rgba(12, 12, 12, 0.2) 85%,
		rgba(12, 12, 12, 1) 100%
	);

	pointer-events: none;

	position: absolute;
	top: 0px;
	left: 0px;
	width: 100vw;
	height: 100vh;
}

.landing-page-content-one {
	height: 70vh;
	margin-top: 100vh;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}

.landing-page-content-one-text {
	width: 40vw;
}

.landing-page__content-two {
	min-height: 50vh;
	display: flex;
	flex-flow: row wrap;
	justify-content: space-around;
	align-items: center;
	padding: 50px 10vw 50px 10vw;
}

.landing-page__content-two__icon-container {
	height: 200px;
	width: 300px;
	margin: 10px;
	display: flex;
	flex-direction: column;
	justify-content: space-around;
	align-items: center;
}

.landing-page__content-two__icon {
	font-size: 10.0em;
}

.landing-page__content-three {
	height: 100vh;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}

.landing-page__bottom-fullscreen-image {
	background-image: url('https://wrkprty.imgix.net/backgrounds/host-info-girl-computer.jpg?q=65&w=1600');
	-webkit-background-size: cover;
	-moz-background-size: cover;
	-o-background-size: cover;
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center;
	height: 100vh;
	width: 100%;
	position: relative;
	&__gradient {
		position: absolute;
		top: 0px;
		left: 0px;
		opacity: 0.99;
		z-index: 1;
		width: 100%;
		/*height: 150px;*/
		height: 100%;
		background: linear-gradient(
			to bottom,
			rgba(250, 250, 250, 1) 0.5%,
			rgba(250, 250, 250, 0) 45%,
			rgba(250, 250, 250, 0) 100%
		);
	}
}

.landing-page__login-button {
	height: 60px!important;
	min-height: 60px!important;
	max-height: 100px!important;
	width: 200px!important;
	min-width: 200px!important;
	max-width: 200px!important;
	font-size: 1.45em!important;
}

.landing-page__carousel {
	height: 500px;
	.carousel-image {
	}
	.carousel-item {
		width: 600px;
	}
}

.card-style {
	position: absolute;
	top: 0px;
	width: 100%;
	background-color: black !important;
}
.landing-card {
	background-color: black !important;
	background: transparent !important;
}

.card__media__background {
	/*opacity: 0.7;*/
}

.card-background-image > div:nth-child(1) {
	/*opacity: 0.7;*/
}

.btn-min-height {
	min-height: 35px;
}

.bg-min-height {
	height: 100vh;
	min-height: 600px;
}

.host-info-header__scroll-icon {
	position: absolute;
	bottom: 5px;
	left: 50%;
	margin-left: -18px;
	animation: float 2s ease-in-out infinite alternate;
	button {
		outline: 0;
	}
	i {
		color: #EEE;
		font-size: 3em;
	}
}
</style>
